import { ref } from 'vue'

const solarIcons = ref<any>(null)
let loadingPromise: Promise<any> | null = null

export const getSolarIcons = async () => {
  if (solarIcons.value) return solarIcons.value
  if (loadingPromise) return loadingPromise

  const basePath = import.meta.env.VITE_BASE_PATH || '/'
  const url = `${basePath.endsWith('/') ? basePath : basePath + '/'}resource/icons/solar.json`.replace(
    /\/\//g,
    '/'
  )
  loadingPromise = fetch(url)
    .then((res) => res.json())
    .then((data) => {
      solarIcons.value = data
      return data
    })
    .catch((err) => {
      console.error('Failed to load solar icons:', err)
      loadingPromise = null
      return null
    })
  return loadingPromise
}

export { solarIcons }
